import es from "./translations/es";
import en from "./translations/en";
import fr from "./translations/fr";
import de from "./translations/de";

export default {
  es,
  en,
  fr,
  de
};
